/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-06-15 16:45:20
 * @LastEditors: linxi
 * @LastEditTime: 2021-07-23 17:14:03
 */
import React from "react";
import styles from "./Progress.module.css";

export interface ProgressProps {
  sortNumber?: number;
  name?: string;
  value?: number;
  max?: number;
  style?: React.CSSProperties;
  sortStyle?: React.CSSProperties;
}

export const Progress: React.FC<ProgressProps> = ({
  sortNumber,
  value,
  name,
  max,
  style,
  sortStyle,
}) => {
  return (
    <div className={styles.progress}>
      <span className={styles.sort} style={sortStyle}>
        {sortNumber}
      </span>
      <div className={styles.content}>
        <div className={styles.contentText}>
          <span>{name}</span>
          <span style={{ color: "#00EDFF" }}>{value}</span>
        </div>
        <p
          style={{
            display: "inline-block",
            height: "0.25em",
            borderRadius: "2px",
            margin: 0,
            background: "rgba(28, 77, 236, 0.2)",
            position: "relative",
            top: "-0.5em",
          }}
        >
          <span
            style={{
              display: "inline-block",
              width: value && max ? `calc((${value / max} * 100%)` : 0,
              height: "0.25em",
              borderRadius: "2px",
              margin: 0,
              background: "linear-gradient(90deg, #004CFF 0%, #00EDFF 100%)",
              position: "absolute",
              ...style,
            }}
          ></span>
        </p>
      </div>
      {/* <p
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          lineHeight: "1.375em",
        }}
      >
        {name}
      </p>
      <span
        style={{
          display: "inline-block",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          lineHeight: "1.375em",
        }}
      >
        {value}
      </span> */}
    </div>
  );
};
